export default __webpack_public_path__ + "static/media/hht2_ep15_book_wp_02.158542a6.jpg";